export const APP_NAME = 'Classovo';
